import { useState } from 'react'
import { useInterval } from 'usehooks-ts'

const useNow = () => {
  const [now, setNow] = useState(new Date())
  useInterval(() => setNow(new Date()), 1000 * 60)
  return now
}

export { useNow }
